import React from 'react';
import * as S from './styled';

const BannerContent = ({ title, children, ...rest }) => (
  <S.BannerContent {...rest} data-testid="banner-content">
    {title && (
      <S.BannerContentTitle data-testid="banner-title">
        {title}
      </S.BannerContentTitle>
    )}
    {children}
  </S.BannerContent>
);

export default BannerContent;
